.hint {
  display: inline-flex;
}

.aside {
  margin-inline-start: auto;
}
